import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import languageService from '../services/language';
import { setLanguage } from './index';

/**
 * Puts the app in the signed-in account's language.
 *
 * The device's last choice is already showing (i18n/index.ts reads it before
 * the first paint); this brings the account's choice in from the server, so
 * a language set on the phone follows the person to the office PC. An
 * account with no language set leaves the device as it is. A failed read
 * changes nothing.
 */
export default function LanguageSync() {
  const { isAuthenticated, user } = useAuth();
  const syncedFor = useRef<number | null>(null);
  const userId = user?.id ?? null;

  useEffect(() => {
    if (!isAuthenticated || userId == null || syncedFor.current === userId) return;
    let cancelled = false;
    languageService.get()
      .then((r) => {
        if (cancelled || !r.success) return;
        // Marked here, not before the request: StrictMode's mount, unmount,
        // mount would otherwise cancel the only request and skip the second.
        syncedFor.current = userId;
        if (r.data.language) void setLanguage(r.data.language);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [isAuthenticated, userId]);

  return null;
}
